const footerLinks = [
    { href: '#team', label: 'The team' },
    { label: 'Security', href: '#security' },
];

export function Footer() {
    return (
        <footer className="mn-on-ink flex w-full flex-wrap items-center justify-between gap-8 bg-background px-[clamp(20px,5vw,48px)] py-12 text-foreground">
            <div className="font-mono text-[12px] tracking-[0.08em] uppercase">
                MohairNotes · mohairnotes.com
            </div>

            <nav
                aria-label="Footer"
                className="flex flex-wrap justify-center gap-8 font-mono text-[14px] text-muted-foreground"
            >
                {footerLinks.map((link) => (
                    <a
                        key={link.href}
                        href={link.href}
                        className="transition-colors duration-200 hover:text-foreground"
                    >
                        {link.label}
                    </a>
                ))}
            </nav>

            <div className="font-mono text-[14px] text-muted-foreground">
                © {new Date().getFullYear()} MohairNotes
            </div>
        </footer>
    );
}
